import { gql } from "@apollo/client";

const schema = {
  request: {
    name: "activateUnitRequest",
    serviceName: "auth",
    query: gql`
      mutation activateUnitRequest($unit_id: String!) {
        activateUnitRequest(unit_id: $unit_id) {
          messages
        }
      }
    `,
  },
};

export default schema;
